//import Libraries
import React from 'react';
import { HashLink as Link } from 'react-router-hash-link';

//import Components
import path from 'path';

//import Style classes
import './SubDepartmentCard.css';


const subDepartmentCard = (props) => {
    const evenOddArray = (arr) => {
        // arr.push(arr[arr.length-1]);
        
        var half = Math.ceil(arr.length/2);
        var arr1 = arr.slice(0,half).reverse();
        var arr2 = arr.slice(half).reverse();
        console.log(arr, half, arr1, arr2);
        var finalArray=[];
        // arr.reverse();
        while(!(arr2.length == 0 && arr1.length == 0)){
            finalArray.push(arr1.pop());
            if(arr2.length !== 0){
                finalArray.push(arr2.pop());
            }
        }
        return finalArray;
    }

    let items = props.data.items.map((obj, idx)=>{
        return (
                <div key={idx} className='ItemCard'>
                    <Link to={props.link+"#"+obj.id}>
                        {obj.name[props.lang]}
                    </Link>
                </div>
        )
    })

    

    return (
            <div className='SubDepartmentCard'>
                <div className="Line"></div>
                <div className="CardTitle" onClick={()=>{window.location.href = "/"+props.link}}>
                    {props.data.name[props.lang]}
                </div>
                <div className={props.subDepartmentCount < 2 ? "ItemCardWrapper Solo":"ItemCardWrapper"}>
                    {props.subDepartmentCount < 2 ? evenOddArray(items) : items}
                </div>
            </div>
    );
}

export default subDepartmentCard;


// WEBPACK FOOTER //
// ./src/pages/Home/Company/DepartmentCard/SubDepartmentCard/SubDepartmentCard.js